import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyB4TjQFCL_Sk4UCD3ix0LNYuUxwLNpixlU',
  authDomain: 'vuejsportfolio.firebaseapp.com',
  databaseURL: 'https://vuejsportfolio.firebaseio.com',
  projectId: 'vuejsportfolio',
  storageBucket: '',
  messagingSenderId: '1087023625465',
  appId: '1:1087023625465:web:de8cf4d13ce95615'
}
firebase.initializeApp(config)
export const functions = firebase.functions()



// WEBPACK FOOTER //
// ./src/plugins/firebase.js